import Compressor from "compressorjs";
import { getFromStorage } from "../helpers";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { MEDIA_UPLOAD } from "../constants/urls";

interface UploadResponse {
  status: number;
  code: number;
  statusCode: number;
  url: string;
  data: any;
  message: string;
}

export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
  return new Promise((resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.6,
      success: (compressedResult) => {
        (async () => {
          const formData = new FormData();
          formData.append("media", compressedResult as any);

          const tempToken = await getFromStorage(STORAGE_KEYS.tempToken);
          const accessToken = await getFromStorage(STORAGE_KEYS.token);
          const headers = {
            Accept: "application/json",
            Authorization: `Bearer ${tempToken ? tempToken : accessToken}`,
          };

          try {
            const res = await fetch(String(MEDIA_UPLOAD), {
              method: "POST",
              headers,
              body: formData,
            });
            const response = await res.json();
            resolve(response);
          } catch (error) {
            reject(error);
          }
        })();
      },
    });
  });
};



export const Uploadpdf = async (imageObject: any) => {
  const formData = new FormData();
  formData.append("media", imageObject as any);
  const accessToken = await getFromStorage(STORAGE_KEYS.token);
  const tempToken = await getFromStorage(STORAGE_KEYS.tempToken);
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${tempToken ? tempToken : accessToken}`,
  };
  try {
    const res = await fetch(String(MEDIA_UPLOAD), {
      method: "POST",
      headers,
      body: formData,
    });
    const response = await res.json();
    return response;
  } catch (error) {
    return error;
  }
};
